import icons from 'url:../../img/icons.svg';
import View from './View';

class PaginationView extends View {
  _parentElement = document.querySelector('.pagination');
  // need a generateMarkup method.  This is the method that render calls to generate the markup for the view we are working on

  // publisher/subscriber pattern
  addHandlerClick(handler) {
    // use event delegation.  There are 2 buttons, but we don't want to listen to them individually.  Rather, let's add the event listener to the common parent element (this._parentElement)
    this._parentElement.addEventListener('click', function (e) {
      // which button was clicked based on the event?  closest() searches down in the tree.
      const btn = e.target.closest('.btn--inline');
      if (!btn) return;
      // the + sign will convert a string to a number
      const goToPage = +btn.dataset.goto;
      handler(goToPage);
    });
  }

  _generateMarkup() {
    const currentPage = this._data.page;
    // we need to know how many pages there are, so let's compute them.  It's the number of results divided by the number of results per page (i.e. 60 results, 10 results per page = 6 pages)
    const totalNumberOfPages = Math.ceil(
      this._data.results.length / this._data.resultsPerPage
    ); // remember that this data is in our controller.js in the 4th step, which is paginationView.render(model.state.search).  we'll need the search object from model.js

    // if we're on page 1 and there are multiple pages
    if (currentPage === 1 && totalNumberOfPages > 1) {
      return `
      <button data-goto="${
        currentPage + 1
      }" class="btn--inline pagination__btn--next">
      <span>Page ${currentPage + 1}</span>
      <svg class="search__icon">
        <use href="${icons}#icon-arrow-right"></use>
      </svg>
    </button>
      `;
    }

    // if we're on the last page
    if (currentPage === totalNumberOfPages && totalNumberOfPages > 1) {
      return `
      <button data-goto="${
        currentPage - 1
      }" class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-left"></use>
            </svg>
            <span>Page ${currentPage - 1}</span>
          </button>
      `;
    }
    // if we're on another page
    if (currentPage < totalNumberOfPages) {
      return `
      <button data-goto="${
        currentPage - 1
      }" class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-left"></use>
            </svg>
            <span>Page ${currentPage - 1}</span>
          </button>
          <button data-goto="${
            currentPage + 1
          }" class="btn--inline pagination__btn--next">
          <span>Page ${currentPage + 1}</span>
          <svg class="search__icon">
            <use href="${icons}#icon-arrow-right"></use>
          </svg>
        </button>
      `;
    }

    // if we're on page 1 and there is only 1 page.  There is no need to show a button since there are no other pages.
    return '';
  }
}
// export the PaginationView object.  It will be imported into our controller.
export default new PaginationView();
